var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sos-btn",on:{"click":function($event){return _vm.$emit('onSosClicked')}}},[_c('div',{staticClass:"nui-icon nui-icon-sos-text sos-icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }